import { Field, Form, Formik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { useApi } from "../../context/ApiProvider";
import ActivityIndicator from "../Helpers/ActivityIndicator";
import Card from "../Helpers/Card";

export default function ClientAdministrators() {
    const Api = useApi();
    const { clientId } = useParams();
    const [client, setClient] = useState(false);
    const [administrators, setAdministrators] = useState(false);
    const [allAdministrators, setAllAdministrators] = useState(false);
    const [addAdministratorError, setAddAdministratorError] = useState(false);
    const [addAdministratorSuccess, setAddAdministratorSuccess] = useState(false);
    const [removeAdministratorError, setRemoveAdministratorError] = useState(false);
    const [removeAdministratorSuccess, setRemoveAdministratorSuccess] = useState(false);


    useEffect(() => {
        refresh()
    }, [])

    const refresh = () => {
        fetchAdministrators();
        fetchAllAdministrators();
    };

    const fetchAdministrators = async () => {
        Api.get(`/clients/${clientId}/administrators`).then(data => {
            setAdministrators(data);
        }).catch(e => {

        })
    }

    const addAdministrator = async (values) => {
        setAddAdministratorError(false);
        setAddAdministratorSuccess(false);
        await Api.post(`/rolf/clients/${clientId}/administrators`, values).then(data => {
            refresh();
            setAddAdministratorSuccess('Administrator added');

        }).catch(e => {
            setAddAdministratorError(e.error);
            console.log(e);
        }).finally(() => {
            setTimeout(() => {
                setAddAdministratorError(false);
                setAddAdministratorSuccess(false);
            }, 3000)
        })
    }

    const removeAdministrator = async (administratorId) => {
        if (!window.confirm('Are you sure you wish to remove this administrator from this client?'))
            return;
        Api.delete(`/rolf/clients/${clientId}/administrators/${administratorId}`).then(data => {
            refresh();
        }).catch(e => {
            console.log(e);
        }).finally(() => {
            setTimeout(() => {
                setRemoveAdministratorError(false);
                setRemoveAdministratorSuccess(false);
            }, 3000)
        })
    }

    const fetchAllAdministrators = async () => {
        Api.get(`/rolf/administrators`).then(data => {
            setAllAdministrators(data);
        }).catch(e => {
            console.log(e);
        })
    }


    return (
        <>
            <div className="grid-container">
                <section className="grow">

                    <h4>Administrators</h4>

                    <table>
                        <thead>
                            <tr>
                                <th>First name</th>
                                <th>Last name</th>
                                <th>Email</th>
                                <th>Last login</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {administrators && administrators.map((admin, index) => (
                                <tr key={index}>
                                    <td>{admin.firstName}</td>
                                    <td>{admin.lastName}</td>
                                    <td>{admin.email}</td>
                                    <td>{admin.lastLogin ? moment.unix(admin.lastLogin).fromNow() : 'Never'}</td>
                                    <td>
                                        <a onClick={() => removeAdministrator(admin.ID)}>Remove</a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {removeAdministratorSuccess && <div className="formControlSuccess">{removeAdministratorSuccess}</div>}
                    {removeAdministratorError && <div className="formControlError">{removeAdministratorError}</div>}





                </section>
                <section>
                    <h4>Add Administrators</h4>
                    <Card>
                        <Formik
                            initialValues={{ administrator: '' }}
                            enableReinitialize={true}
                            onSubmit={(values, { setSubmitting, resetForm }) => {
                                addAdministrator(values).then(() => {
                                    setSubmitting(false);
                                    resetForm();
                                })
                            }}>
                            {({ isSubmitting }) => (
                                <Form>
                                    {addAdministratorSuccess && <div className="formControlSuccess">{addAdministratorSuccess}</div>}
                                    {addAdministratorError && <div className="formControlError">{addAdministratorError}</div>}
                                    <Field as="select" name="administrator" required>
                                        <option value='' disabled>Add from existing</option>
                                        {allAdministrators && allAdministrators.map((admin, index) => (
                                            <option key={index} value={admin.ID}>{admin.firstName} {admin.lastName} - {admin.email}</option>
                                        ))}
                                    </Field>
                                    <button type="submit" disabled={isSubmitting}>Add {isSubmitting && <ActivityIndicator />}</button>
                                </Form>
                            )}
                        </Formik>
                    </Card>
                </section>
            </div>
        </>);
}